<div id="kontaktDaten" [innerHTML]="kontaktText"></div>
<div id='form-btn'>
    <!--<button id="formularAbbrechen" (click)="formularAbbrechen()" class="form-btn">Registrierung verwerfen</button>-->
</div>
